const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, useDots } = window.BAO.Carousel.plugins

const { getOffsetTop } = window.BAO.Utils

class LifestyleGallery extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    this.carousel = this.setupCarousel()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.onScroll = this.onScroll.bind(this)

    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
    this.els.close.elements.forEach((close) => {
      this.listeners.add(close, 'click', this.handleClose)
    })
    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  handleTrigger () {
    document.body.classList.toggle('util-SiteOverflowed', true)
    this.els.modal.element.setAttribute('aria-hidden', 'false')
  }

  handleClose () {
    this.els.modal.element.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveContainer()
  }

  moveContainer () {
    if (!this.offsetHeight) return

    const amountToMoveX = window.BAO.MediaBreakpoints.isMd ? 200 : 60
    const elementHeight = this.offsetHeight

    const elementStartPoint = getOffsetTop(this) - window.innerHeight
    const elementEndPoint = getOffsetTop(this) + elementHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.els.container.element.style.transform = `translate3d(${amountToMoveX / 2}px, 0px, 0px)`

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.els.container.element.style.transform = `translate3d(${amountToMoveX / -2}px, 0px, 0px)`

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      1 - (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const transformAmountX =
      amountToMoveX * scrollYAsAPercentageOfJourney - amountToMoveX / 2

    this.els.container.element.style.transform = `translate3d(${transformAmountX}px, 0px, 0px)`
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
      },
      [
        setInitialised(),
        useDots(this.els?.dot?.elements),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('lifestyle-gallery')) {
  customElements.define('lifestyle-gallery', LifestyleGallery)
}
